<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="groupForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Code</mat-label>
          <input matInput placeholder="" type="text" required formControlName="code" />
          <mat-hint *ngIf="data.edition" align="end"
            >Si vous modifier le code, un nouveau groupe sera créé</mat-hint
          >
          <mat-error>
            <span *ngIf="f('code').hasError('required')">Veuillez saisir un code</span>
            <span *ngIf="f('code').hasError('pattern')"
              >Le code ne peut contenir que des majuscules, chiffres et '_'</span
            >
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Catégorie</mat-label>
          <mat-select formControlName="category" required placeholder="">
            <mat-option *ngFor="let categ of propHelper.getCategories()" [value]="categ">
              {{ propHelper.getCategoryName(categ) }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row">
        <h4>Affichage</h4>
      </div>
      <div formGroupName="display" class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Nom</mat-label>
          <input matInput placeholder="" type="text" required formControlName="name" />
          <mat-error>
            <span *ngIf="f('display.name').hasError('required')">Veuillez saisir un nom</span>
            <span *ngIf="f('display.name').hasError('maxlength')"
              >Le nom ne doit pas dépasser 50 caractères</span
            >
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Ordre</mat-label>
          <input matInput placeholder="" type="text" formControlName="order" nullValue />
          <mat-error>
            <span *ngIf="f('display.order').hasError('pattern')"
              >L'ordre doit être un nombre entier</span
            >
          </mat-error>
        </mat-form-field>
        <mat-slide-toggle
          class="col-md-6"
          formControlName="collapsed"
          [checked]="this.f('display.collapsed').value"
          color="primary"
          >Replié par défaut ?</mat-slide-toggle
        >
      </div>
      <div class="text-center">
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          appTooltip="Valider"
          type="submit"
          [disabled]="formSubmitting"
        >
          Valider
        </button>
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          mat-dialog-close
          appTooltip="Annuler"
          (click)="onNoClick()"
        >
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
